import { useReactiveVar } from '@apollo/client'
import React, { useState } from 'react'
import clsx from 'clsx'
import {
  Drawer,
  Toolbar,
  Box,
  CssBaseline,
  AppBar,
  Hidden,
  MenuItem,
  Typography,
} from '@material-ui/core'
import { isDirtyForm } from '../../graphql/local'
import { CustomPrompt } from '../Common'

import { Footer } from '../Footer'
import { useMenuStyles } from './menuStyles'
import config from '../../config'
import { useHistory } from 'react-router-dom'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { useTranslation } from 'react-i18next'

export const PersonOnboardMenu: React.FC = () => {
  const classes = useMenuStyles()
  const { t } = useTranslation()
  const history = useHistory()
  const isSupportPage = history.location.pathname.includes('contact-support')

  const [showWarning, setShowWarning] = useState(false)
  const isDirtyForms = useReactiveVar(isDirtyForm)

  const handleClose = () => window.close()

  const onClose = () => {
    isDirtyForms ? setShowWarning(true) : handleClose()
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={clsx(classes.appBarShift, classes.appBar)}>
        <Hidden mdUp>
          <Toolbar>
            <Box
              display="flex"
              flexDirection={'column'}
              flexGrow={1}
              alignItems={'center'}
              className={classes.paddingTop}
            >
              <Box className={classes.logo}>
                <img src={config.logo} alt={'company_logo'} />
              </Box>
              {isSupportPage && (
                <MenuItem
                  button
                  onClick={onClose}
                  className={clsx(classes.backItem, classes.centerContent)}
                >
                  <Box component={'span'} className={`${classes.backIcon} black`}>
                    <ArrowBackIcon fontSize="small" />
                  </Box>
                  <Typography variant="body1">
                    <b>{t('closeAndGoBack', 'Close and Go back')}</b>
                  </Typography>
                </MenuItem>
              )}
            </Box>
          </Toolbar>
        </Hidden>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Hidden smDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            <div className={classes.drawerInner}>
              <Box mt={3}>
                <Toolbar className={classes.logoMenu}>
                  <img src={config.logo} alt={'company_logo'} />
                </Toolbar>
                {isSupportPage && (
                  <MenuItem
                    button
                    onClick={onClose}
                    className={clsx(classes.backItem, classes.centerContent)}
                  >
                    <Box component={'span'} className={`${classes.backIcon} black`}>
                      <ArrowBackIcon fontSize="small" />
                    </Box>
                    <Typography variant="body1">
                      <b>{t('closeAndGoBack', 'Close and Go back')}</b>
                    </Typography>
                  </MenuItem>
                )}
              </Box>
              <Box className={classes.footerWrap}>
                <Footer isMenu={true} />
              </Box>
            </div>
          </Drawer>
        </Hidden>
      </nav>

      <CustomPrompt
        open={showWarning}
        onCancel={() => setShowWarning(false)}
        onConfirm={handleClose}
      />
    </div>
  )
}
